<template>
  <!-- 产品相册 -->
  <div class="goods-gallery">
    <div class="goods-gallery-main">
      <PicZoom :url="galleryImage" :scale="1.5"></PicZoom>
    </div>
    <div class="goods-gallery-swiper">
      <swiper
        ref="mySwiper"
        class="swiper-no-swiping"
        :scrollbar="{ draggable: false }"
        :options="swiperOptions"
      >
        <swiper-slide v-for="(item, index) in images" :key="index">
          <img
            class="goods-gallery-img"
            :class="galleryIndex == index ? 'active' :'' "
            :src="item"
            @mouseover="galleryIndex = index"
          />
        </swiper-slide>
        <div
          class="swiper-button-prev"
          slot="button-prev"
          @click="prev"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="next"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import PicZoom from "@/components/PicZoom";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      galleryIndex: 0,
      swiperOptions: {
        slidesPerView: 4,
        grabCursor: false,
        spaceBetween: 5,
      },
    };
  },
  props: {
    images: [],
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    galleryImage() {
      const { images, galleryIndex } = this;
      return images[galleryIndex] ? images[galleryIndex] : "";
    },
  },
  methods:{
      prev(){
          this.swiper.slidePrev()
      },
      next(){
          this.swiper.slideNext()
      }
  },
  components: {
    PicZoom,
    Swiper,
    SwiperSlide,
  },
};
</script>

<style scoped>
.goods-gallery-swiper .swiper-container {
  width: 300px;
  overflow: hidden;
  margin: auto;
}
.goods-gallery-swiper .swiper-button-prev {
  left: 0px;
}
.goods-gallery-swiper .swiper-button-next {
  right: 0;
}
.goods-gallery-swiper .swiper-button-prev::after {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAgCAMAAAAhSXi5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABOUExURUdwTN/f3+Dg4N/f39ra2t/f39/f3+Hh4d/f39/f39/f397e3t/f39/f39/f397e3t/f397e3t/f39/f39/f39zc3N7e3t7e3t3d3d/f3xB3rJQAAAAZdFJOUwDkIIsHrJUD/aDcGrZQ1WlcFH5y8yXHLzyR1lJVAAAAiElEQVQoz53S2w6DMAgGYLpqRV1XD9ON93/RZaMmlv43jgsuvhASDkQmYttQHZHlXvvEIrX/tPKkKgHqUuiqyAnqVOii+oxQ34V6VfdCOmyFBtXHiHSfz9j1AiY+1Oyza3Pjma75iH2w3v/pN+jsjFOud5vxkOuxy0XnaJ/N17c/PIGPJb9+8wc4RRQJ3qd1WAAAAABJRU5ErkJggg==);
  width: 22px;
  height: 32px;
  background-position: -66px 0;
  content: "";
}
.goods-gallery-swiper .swiper-button-next::after {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAgCAMAAAAhSXi5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABOUExURUdwTN/f3+Dg4N/f39ra2t/f39/f3+Hh4d/f39/f39/f397e3t/f39/f39/f397e3t/f397e3t/f39/f39/f39zc3N7e3t7e3t3d3d/f3xB3rJQAAAAZdFJOUwDkIIsHrJUD/aDcGrZQ1WlcFH5y8yXHLzyR1lJVAAAAfUlEQVQoz63SORaAIAwEUFBQ3HFBzf0v6oIWidPoM+VvskyU2mtMFaiOCLh3BLw5lCgTHDT96oXw5PZceIm9+uhWeou9f+fGoramRtrP6DT3IFzDNTaPadFI1ynqwPOE6mPKNPI/gTpEdB3TDOq1sfMi3tMferprwMca+9ANs0IUK6umePsAAAAASUVORK5CYII=);
  width: 22px;
  height: 32px;
  background-position: -66px 0;
  content: "";
}
.goods-gallery-swiper .swiper-button-prev:hover::after{
    background-image: url(data:image/png;base64,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);
     background-position: -1px -140px
}
.goods-gallery-swiper .swiper-button-next:hover:after{
    background-image: url(data:image/png;base64,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);
     background-position: -78px 0;
}
.goods-gallery-img {
  width: 65px;
  height: 65px;
  border: 2px solid #eee;
  cursor: pointer;
}
.goods-gallery {
  width: 370px;
  height: 500px;
}
.goods-gallery-main {
  width: 370px;
  height: 370px;
  border: 1px solid #eee;
}
.goods-gallery-swiper {
  margin: 10px auto;
  width: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
  position: relative;
  overflow: hidden;
}
.goods-gallery-img.active{
    border: 2px solid #ff0000;
}
</style>


// WEBPACK FOOTER //
// src/components/GoodsGallery/index.vue